import AOS from "aos";

import "@fortawesome/fontawesome-free/js/all.js";

import { enhance, handle } from "@grrr/hansel";
import { onDomReady } from "@grrr/ready";
import { svgInline } from "./modules/svg";
import { iframeEnhancer } from "./modules/iframe";
import { menuToggle } from "./modules/menu";
import {
    adjustToHeight,
    clonePosition,
    followLinkAttribute,
} from "./modules/malou";
import {colorPicker, disableColorPopup, setColor, submitColor} from "./modules/color-picker";

window.mmEnhancers = {
    svgInline,
    iframeEnhancer,
    menuToggle,
    adjustToHeight,
    clonePosition,
    colorPicker,
};

window.mmHandlers = { followLinkAttribute, setColor, submitColor, disableColorPopup };

onDomReady(() => {
    enhance(document.documentElement, window.mmEnhancers);
    handle(document.documentElement, window.mmHandlers);

    AOS.init();
});
